import type {SVGProps} from 'react'
const MenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M100 300h800v50H100zm0 350h800v50H100z" />
  </svg>
)
export {MenuIcon}
